var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSmeMedicalBlue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "25.000000pt",
    height: "21.000000pt",
    viewBox: "0 0 30.000000 26.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,26.000000) scale(0.100000,-0.100000)",
    fill: "#0F3ECA",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M90 230 c0 -29 -2 -30 -45 -30 l-45 0 0 -100 0 -100 150 0 150 0 0 100 0 100 -45 0 c-43 0 -45 1 -45 30 l0 30 -60 0 -60 0 0 -30z m100 -10 c0 -17 -7 -20 -40 -20 -33 0 -40 3 -40 20 0 17 7 20 40 20 33 0 40 -3 40 -20z m90 -65 l0 -25 -130 0 -130 0 0 25 0 25 130 0 130 0 0 -25z m-150 -65 c0 -5 9 -10 20 -10 11 0 20 5 20 10 0 6 25 10 55 10 l55 0 0 -40 0 -40 -130 0 -130 0 0 40 0 40 55 0 c30 0 55 -4 55 -10z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmeMedicalBlue);
export default __webpack_public_path__ + "static/media/sme_medical_blue.977fe3683f8f7e429353a97551bd8ff2.svg";
export { ForwardRef as ReactComponent };